import { render, staticRenderFns } from "./insurance-coverage.vue?vue&type=template&id=3fec8c6e"
import script from "./insurance-coverage.vue?vue&type=script&lang=js"
export * from "./insurance-coverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports